import { ref } from 'vue'

// Lets the currently-mounted CalendarFilterBar (Day/Week/Month, wherever a
// calendar view is showing) register its Teachers dropdown so the global "t"
// shortcut (AppRoot.vue) can open it without either side knowing about the
// other's component tree — same pattern as useActiveSearchFocus. Module-level
// singleton: if more than one CalendarFilterBar is ever mounted at once, the
// most recently mounted one wins. It also registers a clear-all-filters function
// for the global "c" shortcut.
const openFn = ref(null)
const availableFn = ref(() => false)
const clearFn = ref(null)

export function useActiveTeacherDropdown() {
  return {
    isAvailable: () => availableFn.value(),
    canClear: () => !!clearFn.value,
    register: (open, isAvailable, clear) => { openFn.value = open; availableFn.value = isAvailable; clearFn.value = clear },
    unregister: open => {
      if (openFn.value === open) { openFn.value = null; availableFn.value = () => false; clearFn.value = null }
    },
    clear: () => clearFn.value?.(),
    open: () => {
      if (!availableFn.value()) return false
      openFn.value?.()
      return true
    },
  }
}
